import { Menu } from 'antd';
import styled from 'styled-components';

import { Button } from 'components/ui';

export const TEMPLATES_MENU_ITEM_CLASS_NAME = 'create-task-templates-menu-item';

export const CreateTaskContainer = styled.div`
  padding: 0 1em;
`;

export const CreateTaskButton = styled(Button)`
  padding: 0;
`;

export const StyledMenu = styled(Menu)`
  .ant-menu-item {
    font-size: 0.85rem;
    height: 1.35rem;
    line-height: 1.35rem;
    padding: 0 5px;
    margin-inline: 0;
    width: 100%;
  }

  .ant-menu-item .anticon {
    font-size: 0.75rem;
  }

  // This item holds the whole TaskTemplatesChooser menu, so it takes that menu's height.
  .ant-menu-item.${TEMPLATES_MENU_ITEM_CLASS_NAME} {
    height: auto;
    line-height: normal;
    padding: 0;
  }
`;
